import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedPageConfirmation: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RestrictedPageConfirmation" */ '../src/RestrictedPageConfirmation.js'
			)
		).RestrictedPageConfirmation,
});
